import styled from 'styled-components';

export const Frame1MobileWrapper = styled.div`
  margin-bottom: 30px;
`;
